<template>
  <div class="VIPclass">
    <!-- 搜索 -->
    <kind-choose-view :is-jinpin="false" :show-school="true" :show-kc="false" :show-zy="true" :type="null"
      @isOk="isOk" />
    <!-- 套餐列表 -->
    <div class="contentWrap">
      <div v-for="(item, index) in exclusiveClassList" :key="index" class="contentItem" @click="goDetails(item)">
        <div class="imgItem">
          <img :src="item.img" class="img">
          <div v-if="item.productLine === '5'" class="oneToOne" />
          <div v-else class="imgTips">VIP专属</div>
        </div>
        <div class="titleItem twoEllipsis">
          <span v-if="item.isHavePrivateClass == 1" class="xbk"> <img src="~@/assets/img/typeclass/z1.png" alt="">
          </span>{{ item.tiitle }}
        </div>
        <div class="priceItem">
          <div class="symbolOrprice">
            <span class="symbol">{{ '￥' }}</span>
            <span class="price">{{ item.price }}</span>
          </div>
          <span v-if="item.productLine !== '5'" class="courseNum">{{ item.kechengNum ? item.kechengNum + '门课程' : '暂无课程'
            }}</span>
        </div>
        <div class="line" />
        <div v-if="item.productLine === '5'" class="bottomTips">
          <div class="topTips">
            <img class="incon" src="@/assets/img/Home/group2830.png">
            <span class="tipsFirst">专属服务：</span>
            <span class="tipsItem">1对1直播</span>
            <div class="verticalLine" />
            <span class="tipsItem">专属教务</span>
          </div>
        </div>
        <div v-else class="bottomTips">
          <div class="topTips">
            <img class="incon" src="@/assets/img/Home/group2830.png">
            <span class="tipsFirst">专属服务：</span>
            <span class="tipsItem">8小时极速答疑</span>
            <div class="verticalLine" />
            <span class="tipsItem">督学跟踪</span>
          </div>
          <div class="topTips">
            <span class="tipsItem">专属资料</span>
            <div class="verticalLine" />
            <span class="tipsItem">专属考场</span>
            <div class="verticalLine" />
            <span class="tipsItem">专属教材</span>
            <div class="verticalLine" />
            <span class="tipsItem">定期班会</span>
          </div>
        </div>
      </div>
      <div style="margin: 0 auto;" v-if="exclusiveClassList.length == 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>
    <!-- 分页 -->
    <el-pagination class="pagination" :current-page="pageNum" :page-sizes="[12, 24, 36, 48]" :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>

<script>
import KindChooseView from '../../components/kindChooseViewkvip.vue'
import { selectPageListToIndex } from '@/api/home'
export default {
  components: {
    KindChooseView
  },
  data() {
    return {
      exclusiveClassList: [],
      pageSize: 12,
      pageNum: 1,
      total: 0,
      search: {},
      loading: null
    }
  },
  async beforeDestroy() {
    this.loading.close()
  },
  created() {
    this.selectPageListToIndex()
  },
  methods: {
    /* 筛选 */
    isOk(val) {
      this.pageNum = 1
      this.search = val
      this.selectPageListToIndex()
    },
    /* VIP专属班列表 */
    selectPageListToIndex() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      selectPageListToIndex(
        this.pageSize,
        this.pageNum,
        this.search.school,
        this.search.kind,
        this.search.zyId,
        undefined,
        3, /* productLine 3专属线 */
        this.search.areaId == 1 ? undefined : this.search.areaId,
        this.search.name ? this.search.name : undefined
      ).then((res) => {
        this.exclusiveClassList = res.rows
        this.total = res.total
        this.loading.close()
      }).catch(() => {
        this.loading.close()
      })
    },
    /* 点击进入专属班详情 */
    goDetails(item) {
      let routeUrl = ''
      if (item.productLine === '5') {
        routeUrl = this.$router.resolve({
          path: '/VIP/oneToOneClass',
          query: {
            id: item.id
          }
        })
      } else {
        routeUrl = this.$router.resolve({
          path: '/VIP/VIPClassxq',
          query: {
            id: item.id
          }
        })
      }
      window.open(routeUrl.href, '_blank')
    },
    /* 每页条数 */
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.selectPageListToIndex()
    },
    /* 当前页码 */
    handleCurrentChange(val) {
      this.pageNum = val
      this.selectPageListToIndex()
    }
  }
}
</script>

<style lang="less" scoped>
.VIPclass {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  overflow: hidden;

  .contentWrap {
    margin: 40px auto;
    width: calc(1220px + 24px);
    height: auto;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;

    .contentItem {
      width: 287px;
      height: 364px;
      background-color: #ffffff;
      border-radius: 8px;
      margin-bottom: 24px;
      cursor: pointer;
      margin: 0 24px 24px 0;

      .imgItem {
        width: 287px;
        height: 161px;
        position: relative;

        .img {
          width: 287px;
          height: 161px;
          border-radius: 8px 8px 0 0;
        }

        .imgTips {
          width: 80px;
          height: 26px;
          background: linear-gradient(134deg, #5e6c77 0%, #222733 100%);
          border-radius: 8px 0 8px 0;
          text-align: center;
          line-height: 26px;
          color: #ffbe5d;
          font-size: 14px;
          font-family: Microsoft YaHei-Bold;
          font-weight: bold;
          font-style: italic;
          position: absolute;
          top: 0;
          left: 0;
          /* -webkit-background-clip: text; */
          /* -webkit-text-fill-color: transparent; */
        }

        .oneToOne {
          border-radius: 8px 0 8px 0;
          width: 77px;
          height: 24px;
          background: url("~@/assets/img/Home/oneToOne/one-to-one-tips.png");
          position: absolute;
          top: 0;
          left: 0;
          color: #ffffff;
          line-height: 24px;
          padding-left: 9px;
        }
      }

      .titleItem {
        margin: 12px auto 0 auto;
        width: 245px;
        height: 48px;
        font-size: 16px;
        font-family: Microsoft YaHei-Regular;
        color: #333333;
        line-height: 24px;
        position: relative;
      }

      .priceItem {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 16px 0 16px;

        .symbolOrprice {
          .symbol {
            font-size: 14px;
            color: #ff5e51;
          }

          .price {
            color: #ff5e51;
            font-size: 18px;
            font: bold;
            font-family: Microsoft YaHei-Bold;
          }
        }

        .courseNum {
          color: #999999;
          font-size: 12px;
          font-family: Microsoft YaHei-Regular;
        }
      }

      .line {
        height: 1px;
        width: 255px;
        background-color: #eeeeee;
        margin: 20px auto 17px auto;
      }

      .bottomTips {
        width: 100%;
        padding: 0 16px;
        display: flex;
        flex-direction: column;

        .topTips {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          .incon {
            display: inline;
            margin-right: 4px;
          }

          .tipsFirst {
            font-size: 12px;
            color: #666666;
            font-family: Microsoft YaHei-Regular;
          }

          .tipsItem {
            font-size: 12px;
            color: #999999;
          }

          .verticalLine {
            width: 1px;
            height: 8px;
            background-color: #dddddd;
            display: inline-block;
            margin: 0 10px;
          }
        }
      }
    }
  }

  .pagination {
    margin: auto;
  }
}

.xbk {
  img {
    width: 60px !important;
    height: 22px !important;
    display: inline !important;
    margin-right: 8px !important;
    position: relative;
    top: 5px;
  }
}
</style>
